import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import { Tween } from '../tweens.js';
import * as player from '../player.js';

export {
    init,
}

const POIs = [
    {
        name: 'demo-rouge',
        position: { x: -8, y: -8, z: 3 }, // In meters, Top Left
        color: 'red',
        radius: 5,
        sound: {
            name: 'grains_pluie',
            gain: 0,
        },
        collision: {
            radius: 1,
        },
        onEnter() {
            // Follow player
            const originalPosition = { ...this.position };
            new Tween(this.position, player.position, 1, 'easeOutQuad', (v) => {
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween) => {
                setTimeout(() => {
                    // Manual cleanup to stop following player
                    tween.dispose();
                    new Tween(this.position, originalPosition, 4, 'easeInOutQuad', (v) => {
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new Tween(12, 5, 2, 'easeOutQuad', (v) => {
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new Tween(this.radius, 12, 0.5, 'easeOutQuad', (v) => {
                this.radius = v;
            });
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'demo-bleu',
        position: { x: 8, y: -8, z: 0.2 }, // In meters, Top Right
        color: 'blue',
        sound: {
            name: 'hydro',
            gain: 0,
        },
        collision: {
            radius: 1,
        },
        onEnter() { this.sound.source.fadeTo(2, -90, 0) },
        onLeave() { this.sound.source.fadeTo(2, 0, -90) },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'demo-vert',
        position: { x: 8, y: 8, z: 0.5 }, // In meters, Bottom Right
        color: 'green',
        radius: 15,
        sound: {
            name: 'metal-guitar',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'demo-jaune',
        position: { x: -8, y: 8, z: 1.8 }, // In meters, Bottom Left
        color: 'yellow',
        sound: {
            name: 'histoire',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
]

const sounds = [
    { name: 'grains_pluie', url: new URL('../../sound/grains_pluie.wav', import.meta.url) },
    { name: 'hydro', url: new URL('../../sound/hydro.wav', import.meta.url) },
    { name: 'histoire', url: new URL('../../sound/histoire.wav', import.meta.url) },
    { name: 'metal-guitar', url: new URL('../../sound/metal-guitar.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    loader.addImages(images);
    loader.addSounds(sounds);
};
